/**
 * Created by Mark on 24/11/2016.
 */

import BaseStore from './base-store.js';
import Constants from '../constants/staff.js';
import Class from '../classes/class.js'
import InternationalizationStore from './internationalization-store.js';
class Staff {
    constructor(uid, name, username, password, classes , user_type) {
        this.uid = uid;
        this.name = name;
        this.userType  = user_type;
        this.userTypeText = user_type == "school" ? InternationalizationStore.getTranslation('ui-681' , "") : InternationalizationStore.getTranslation('ui-4' , "")
        this.username = username;
        this.password = '**********'
        this.profileLink = this.getLink();
        this.assignedHomework = 0
        this.completedHomework = 0;
        this.totalStudentsLink = this.getStudentsLink()
        this.rank = 0;
        this.wordsLearnt = 0;
        this.learnt = 0;
        this.classesLinks = (classes || []).map(function (_class) {
            return new Class(_class.uid, _class.name, _class.students || []).getLink();
        })
        this.classes = (classes || []).map(function (_class) {
            return new Class(_class.uid, _class.name, _class.students || []);
        })

    }

    get(key) {
        return this[key] || 'undefined';
    }

    getName() {
        return this.name;
    }

    getLink() {
        return {link: 'student/profile/' + this.uid, value: this.name};
    }

    getStudentsLink() {
        return {link: 'class/profile/' + this.uid + '/students', value: 3};
    }

    getUserType(){
        return this.userType
    }
    getID() {
        return this.uid;
    }
}

class StaffStore extends BaseStore {

    constructor() {
        super();
        this.subscribe(() => this._registerToActions.bind(this));
        this.allStaff = [];
    }

    _registerToActions(action) {

        switch(action.actionType)
        {
            case Constants.UPDATE_ALL_STAFF:

                this.allStaff = action.response.map(function(__staff){
                    return new Staff(__staff.uid , __staff.name , __staff.username , __staff.password , __staff.classes , __staff.user_type)
                });

                this.emitChange();

                break;
        }
    }


    getStaff(id){
        for(var idx = 0 ; idx < this.allStaff.length; idx++)
        {
            if(id == this.allStaff[idx].uid) return this.allStaff[idx];
        }

        return null;
    }

}

export default new StaffStore();


// WEBPACK FOOTER //
// ./src/store/staff-store.js